<div class="flex flex-row justify-center">
  <div class="flex flex-col items-center view-container">
    <div class="manual-input">
      <h3 class="headline-3 text-center mb-2">{{ '#COUPONS.STARTPAGE.MANUAL_INPUT' | translate }}</h3>
      <div class="flex flex-row barcode-input-container soft-input mt-3 mb-5">
        <label for="barcode-input" style="width: 100%">
          <input id="barcode-input" placeholder="Gutschein-Code" (input)="checkCodeLength(input.value)" #input>
        </label>
        <button
          class="soft-button secondary custom-button-size"
          (click)="getCoupon(input.value, 'code39')"
          [disabled]="inputDisabled">
          {{ '#COUPONS.STARTPAGE.START_BTN' | translate }}
        </button>
      </div>
    </div>
    <p class="text-body light uppercased weight-medium">{{ '#COUPONS.STARTPAGE.OR' | translate }}</p>
    <div class="flex flex-row justify-center soft-card scan-action-card !py-8 !px-7 mt-5 press-shadow" (click)="onScanClick()">
      <div class="flex flex-row flex-nowrap content gap-4">
        <div class="content-icon">
          <i class="fa-regular fa-barcode-scan barcode-icon text-[3.5rem]" alt="barcode-symbol"></i>
        </div>
        <div class="flex flex-col content-text">
          <h3 class="headline-3 !text-2xl">{{ '#COUPONS.STARTPAGE.SCAN_COUPON' | translate }}</h3>
          <p class="text-body text-base text-light">{{ '#COUPONS.STARTPAGE.SCAN_DESCRIPTION' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

@if (isLoading$ | async) {
  <div class="spinner-container">
    <div class="spinner-background">
      <soft-loading-spinner></soft-loading-spinner>
      <div class="flex flex-col items-center mt-5">
        <h5 class="font-semibold loading-text">{{ '#COUPONS.STARTPAGE.LOADING' | translate }}</h5>
        <div class="loading-desc">{{ '#COUPONS.STARTPAGE.LOADING_DESC' | translate }}</div>
      </div>
    </div>
  </div>
}
